import React from 'react'
import styled, {keyframes} from 'styled-components'

const dash = offset => keyframes`
    0% {
        stroke-dashoffset: ${offset};
    }
    50% {
        stroke-dashoffset: ${offset / 4};
        transform: rotate(135deg);
    }
    100% {
        stroke-dashoffset: ${offset};
        transform: rotate(450deg);
    }
`

const rotator = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(270deg);
    }
`

const Container = styled.svg.attrs({
    viewBox: props => `0 0 ${props.size} ${props.size}`,
    xmlns: 'http://www.w3.org/2000/svg',
})`
    animation: ${rotator} 1.4s linear infinite;
    width: ${props => props.size - 1}px;
    height: ${props => props.size - 1}px;
    display: block;
`

const Circle = styled.circle.attrs({
    offset: props => props.size * Math.PI,
    fill: 'none',
    strokeLinecap: 'round',
    cx: props => props.size / 2,
    cy: props => props.size / 2,
    r: props => (props.size - props.strokeWidth) / 2,
    strokeWidth: props => props.strokeWidth,
})`
    stroke-dasharray: ${props => props.offset};
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: ${props => dash(props.offset)} 1.4s ease-in-out infinite;
    stroke: ${props => props.tint};
`

const Spinner = ({tint, size, strokeWidth, className, ...rest}) => (
    <Container size={size} {...rest}>
        <Circle size={size} strokeWidth={strokeWidth} tint={tint} />
    </Container>
)

Spinner.defaultProps = {
    tint: '#E0E6ED',
    size: 22,
    strokeWidth: 2,
}

export default Spinner
